import React from 'react';

import { MenuProduct } from './menu-product-v2';

// old - not one menu
export const MenuObjectPage = () => {
  return <MenuProduct />;
};
